import { cn } from "@/lib/cn";

interface ColorSwatchProps {
    hexColor: string | null | undefined;
    name: string | null | undefined;
    selected: boolean;
    onClick: () => void;
    size?: "sm" | "md";
}

export function ColorSwatch({
    hexColor,
    name,
    selected,
    onClick,
    size = "md",
}: ColorSwatchProps) {
    return (
        <span className="group relative inline-block">
            <button
                type="button"
                onClick={onClick}
                data-testid="color-swatch"
                className={cn(
                    "relative rounded-md border-2 transition-all cursor-pointer",
                    size === "sm" ? "size-7" : "size-9",
                    selected
                        ? "border-primary scale-110 shadow-md"
                        : "border-gray-200 hover:border-gray-400",
                )}
                style={{ background: hexColor ?? "#ccc" }}
            >
                <span className="sr-only">{name}</span>
            </button>
            {name && (
                <span
                    data-testid="color-swatch-tooltip"
                    className="pointer-events-none absolute bottom-full left-1/2 z-10 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100"
                >
                    {name}
                </span>
            )}
        </span>
    );
}
